//
import React, { Fragment } from 'react';
import { Alert } from 'localmed-core';
import { FLASH_MESSAGES } from '../../../shared/constants';
import { getQueryFromLocation } from '../../../shared/utils/urls';

export default function ProviderPageFlashMessage({ location, ...props }) {
  const query = getQueryFromLocation(location);
  const hasNotAvailableMessage = query.message === FLASH_MESSAGES.OPENING_NOT_AVAILABLE;
  const appointmentCancelled = query.message === FLASH_MESSAGES.APPOINTMENT_CANCELED;
  return (
    <Fragment>
      {hasNotAvailableMessage && (
        <Alert tier="error" {...props}>
          We’re sorry, but the appointment you requested is no longer available. Please select from
          the available appointments.
        </Alert>
      )}

      {appointmentCancelled && (
        <Alert tier="success" {...props}>
          Your appointment has been successfully canceled.
        </Alert>
      )}
    </Fragment>
  );
}
